import '../components/styles/home-page.css'
import Layout from '../components/layout'
import Main from '../components/Main';
import Cta from '../components/Cta';
import Service from '../components/Service';
import CtaTwo from '../components/CtaTwo';
import Pricing from '../components/Pricing';
import Reviews from '../components/Reviews';
import FileSection from '../components/FileSection';
import Features from '../components/Features';
import ContactUs from '../components/ContactUs';

const HomePage = () => {
    return (
        <Layout>
            <Main/>
            <Cta/>
            <Service/>
            <CtaTwo/>
            <Pricing/>
            <Reviews/>
            <FileSection/>
            <Features/>
            <ContactUs/>
        </Layout>
    );
}

export default HomePage;
